export default __webpack_public_path__ + "static/media/blob.left-corner.d15a6d97.png";